<div *ngIf="!_autoMl.isAutoMl" class="scad-body">
    <app-flow-left-inputs></app-flow-left-inputs>
    <div class="scad-body__wrapper" [ngClass]="{'full-width': sideBarMinimized || sideBartoggle }">
        <app-flow-header></app-flow-header>
        <div class="scad-body__main">
            <div>
                <app-top-action-area></app-top-action-area>
            </div>
            <div>
              <app-flow-landing-page></app-flow-landing-page>
            </div>
            <div class="bottom-area-section">
              <app-flow-bottom-area></app-flow-bottom-area>
            </div>
        </div>
    </div>
</div>

<app-auto-ml-overview *ngIf="_autoMl.isAutoMl"></app-auto-ml-overview>
